import qs from 'qs';
import { tokenKey } from '@loyalty/auth';
import { useAlerts } from '@qualifio/ui-commons';
import { useCallback } from 'react';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useApi } from './api-client/ApiClientProvider';

export function usePortalUrl(programId: string) {
  const { notify } = useAlerts();
  const { t } = useTranslation();
  const { gamificationApi, managerApi, profileApi } = useApi();
  const program = useQuery({
    queryFn: () => gamificationApi.getProgram(programId),
    queryKey: ['program', programId],
  });
  const embedData = useSuspenseQuery({
    queryFn: () => managerApi.getEmbed(programId),
    queryKey: ['program', programId, 'embed'],
  });

  const openPortal = useCallback(
    async (params: { profileId?: string; templateId?: string; withInterAuth?: boolean }) => {
      if (!program.data || !embedData.data) {
        throw new Error('Program misconfiguration');
      }

      let impersonationToken: string | undefined;

      if (params.withInterAuth) {
        const { impersonationToken: token } = await profileApi.upsertProfile(
          program.data.accountId,
          {
            id: params?.profileId,
            memberships: [{ programId }],
          },
          {
            params: {
              impersonate: true,
              internalUser: true,
              tokenExtraInfo: {
                programId,
              },
            },
          },
        );
        if (!token) {
          throw new Error();
        }
        impersonationToken = token;
      }

      const queryParams: Record<string, string> = {};
      if (params?.withInterAuth && impersonationToken) {
        queryParams[tokenKey] = impersonationToken;
      }
      if (params?.templateId) {
        queryParams.templateId = params.templateId;
      }

      const portalUrlWithToken =
        embedData.data.webview + qs.stringify(queryParams, { addQueryPrefix: true });

      console.log(portalUrlWithToken);
      window.open(portalUrlWithToken, '_blank');
    },
    [program.data, embedData.data],
  );

  const getPortalUrl = useCallback(() => {
    if (!embedData.data) {
      throw new Error('Program misconfiguration');
    }
    return embedData.data.webview;
  }, [program.data, embedData.data]);

  return {
    openPortal,
    getPortalUrl,
  };
}
